export enum VideoTypes {
    DASH_WEBM = 'video-webm',
    DASH_FMP4 = 'video-fmp4',
    EPICHOSTED = 'epicHosted',
    EXTERNAL = 'externalVideo',
    HTML = 'htmlVideo',
    HLS = 'video-hls',
    TWITCH = 'twitchVideo',
    TWITCH_STREAM = 'twitchStream',
    YOUTUBE = 'youtubeVideo'
}

const typesWithTopContent: VideoTypes[] = [
    VideoTypes.TWITCH,
    VideoTypes.TWITCH_STREAM,
    VideoTypes.YOUTUBE
];

export enum epicStillTypes {
    APPEND = 'APPEND',
    PREPEND = 'PREPEND',
    OVERLAY_DEFAULT = 'OVERLAY_TL',
    OVERLAY_INT = 'OVERLAY_INTERNAL',
    OVERLAY_TL = 'OVERLAY_TL',
    OVERLAY_TR = 'OVERLAY_TR',
    OVERLAY_BL = 'OVERLAY_BL',
    OVERLAY_BR = 'OVERLAY_BR'
}

export enum VideoCommands {
    PLAY = 'playVideo',
    PAUSE = 'pauseVideo',
    TOGGLE = 'toggleVideo'
}

/**
 * Privacy-enhanced mode uses youtube-nocookie.com.
 * @see {@link https://support.google.com/youtube/answer/171780?hl=en}
 */
const YOUTUBE_BASE_URL = 'https://www.youtube-nocookie.com/embed';
const TWITCH_BASE_URL = 'https://player.twitch.tv';

export default {
    epicStillTypes,
    types: VideoTypes,
    typesWithTopContent,
    commands: VideoCommands,
    YOUTUBE_BASE_URL,
    TWITCH_BASE_URL
};
